import { getBackendHealth, parseFormulaWithBackend } from "../services/api";

export const isOpenAIConfigured = async () => {
  try {
    const health = await getBackendHealth();
    return Boolean(health.openaiConfigured);
  } catch (error) {
    return false;
  }
};

export const processApiResponse = async ({ inputText, imageBase64 }) =>
  parseFormulaWithBackend({ inputText, imageBase64 });
